export default {
  header: 'Vi skal bekræfte dit telefonnummer',
  buttons: {
    confirm: 'Bekræft',
  },
  toasts: {
    invalid_code: 'Ugyldig kode. Prøv igen.',
  },
};
